(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const header = document.querySelector('.header-wrapper, sticky-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (reduce) {
    document.querySelectorAll('.meroo-reveal').forEach((el) => el.classList.add('is-in'));
    return;
  }

  const reveals = document.querySelectorAll('.meroo-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );
    reveals.forEach((el, index) => {
      el.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 80}ms`);
      observer.observe(el);
    });
  }

  /* Large parallax disabled, design system forbids excessive movement */
  const heroImage = document.querySelector('.meroo-hero__image');
  if (heroImage) {
    heroImage.style.transform = '';
  }
})();
